/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
// ...existing code...
// import { set } from "date-fns";
import React, { useEffect, useState } from "react";
import { showInvalidAddressToast } from "../toasts";
import { Controller } from "react-hook-form";
import useManualFields from "../hooks/useManualFields";
import ManualField from "./ManualField";
import ControlledField from "./ControlledField";
import { useAuth, isGuestUser } from "../../../../context/AuthContext";
// import Modal from '../../../../components/common/Modal';
import EscrowTitleFields from "./EscrowTitleFields";
// import CountyAssessorModal from "../../popups/CountyAssessorModal";
import DisclaimerModal from "../../popups/DisclaimerModal";
import EmailModal from "../../popups/EmailModal";
import TextMessageModal from "../../popups/TextMessageModal";
import SellerClosingCosts from "./SellerClosingCosts";
import OtherCostsFields from "./OtherCostsFields";
import DiscountFields from "./DiscountFields";
import LoansToBePaid from "./LoansToBePaid";
// import AddressFields from "./AddressFields";
import { formatCurrency } from "../../../../utils/format";
import CompensationFields from "./CompensationFields";
import OwnerCarrySection from "./OwnerCarrySection";
// import { saveSellerCalc } from "../services/sellerNetService";
import { CommonHeader } from "../../../../components/ui/CommonHeader";
import { useModal } from "../../../../context/ModalContext";
import { buildSellerNetPayload } from "../../../../utils/payloadBuilder";
import GeneralInformationSection from "../../components/GeneralInformationSection";

export default function ManualSheetSection(props) {
  const {
    FloatingInput,
    FloatingNumber,
    CustomSelect,
    handleCurrencyBlur,
    onSalesPriceBlur,
    control,
    watch,
    setValue,
    getValues,
    sellerClosingCostArray,
    closingCostsSection2Array,
    sellerOtherCostArray,
    compensationArray,
    otherCostArray,
    cleanNumber,
    checkValidSalesPrice,
    handleDownloadPrintPDF,
    handleSellerCalculation,
    setUseMortgageBalance,
    ttbData,
    showToaster,
    templateMissing,
    calcCompleted,
    onAttemptEditAfterComplete,
  } = props;

  const { user } = useAuth();
  const ucWords = (str = "") =>
    str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  const fullName = ucWords(
    `${user.first_name ?? ""} ${user.last_name ?? ""}`
  ).trim();

  const [salesPriceFormattedTick, setSalesPriceFormattedTick] = useState(0);
  const [isCalculating, setIsCalculating] = useState(false);
  const [EscrowDisabled, setEscrowDisabled] = useState({
    escrowSettlement: true,
    ownersPolicy: true,
    lendersPolicy: true,
    premiumText: "",
  });

  // helper to read current form values when migrating off legacy `formData` prop
  const getVal = (path, fallback = "") => {
    try {
      if (typeof getValues === "function") {
        const v = getValues(path);
        return v === undefined ? fallback : v;
      }
    } catch (e) {
      // ignore and return fallback
    }
    return fallback;
  };

  const loanType =
    getVal(
      "loanInfoMeta.buyersLoanType",
      getVal("loanInfoMeta")?.buyersLoanType
    ) ||
    getValues?.loanInfoMeta?.buyersLoanType ||
    "Conventional";
  // Subscribe to salesPrice so this component re-renders when salesPrice is programmatically updated
  const watchedSalesPrice =
    typeof watch === "function" ? watch("salesPrice") : undefined;
  // Prefer RHF useFieldArray fields when available; fall back to legacy formData parsedSection2 only for templates
  const parsedSection2 =
    closingCostsSection2Array &&
      Array.isArray(closingCostsSection2Array.fields) &&
      closingCostsSection2Array.fields.length
      ? closingCostsSection2Array.fields
      : getVal("closingCostMeta", getVal("parsedSection2", [])) || [];
  const costRows = useManualFields(parsedSection2);

  const { openModal, closeModal } = useModal();
  // NOTE: synchronization of loan fields with the mortgage balance preference
  // has been moved to the parent `SellerNetSheet` so it can centrally update
  // RHF values (setValue/getValues) and avoid duplicated logic across children.

  const handleFocusCapture = (e) => {
    try {
      if (!calcCompleted) return;
      const target = e?.target;
      if (!target) return;

      // CustomSelect uses div/li elements, not a native <select>.
      try {
        if (typeof target.closest === "function" && target.closest(".custom-select")) {
          // Prevent editing by immediately blurring and opening the prompt.
          try {
            target.blur && target.blur();
          } catch (err) {
            /* ignore */
          }
          try {
            e.preventDefault && e.preventDefault();
            e.stopPropagation && e.stopPropagation();
          } catch (err) {
            /* ignore */
          }

          if (typeof onAttemptEditAfterComplete === "function") {
            onAttemptEditAfterComplete();
          }
          return;
        }
      } catch (e) {
        /* ignore */
      }

      const tag = (target.tagName || "").toString().toLowerCase();
      const isEditable =
        tag === "input" ||
        tag === "textarea" ||
        tag === "select" ||
        !!target.isContentEditable;
      if (!isEditable) return;

      // Prevent editing by immediately blurring and opening the prompt.
      try {
        target.blur && target.blur();
      } catch (err) {
        /* ignore */
      }
      try {
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
      } catch (err) {
        /* ignore */
      }

      if (typeof onAttemptEditAfterComplete === "function") {
        onAttemptEditAfterComplete();
      }
    } catch (err) {
      // ignore
    }
  };

  useEffect(() => {
    if (user?.first_name || user?.last_name) {
      setValue("preparedBy", fullName);
    }
  }, [user, setValue, fullName]);

  const handleContinue = (setting) => {
    const pstString = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles",
    });
    const [pstDate, pstTimeFull] = pstString.split(", ");
    const pstTime =
      pstTimeFull?.split(":").slice(0, 2).join(":") +
      (pstTimeFull?.includes("AM") ? " AM" : " PM");

    // console.log(getValues('escrowPremiumChanged'))
    let premiumText = `*Premium changed ${fullName} ${pstDate} ${pstTime} PST`;
    setEscrowDisabled((prev) => ({
      ...prev,
      ...setting,
      premiumText: premiumText,
    }));

    setValue("escrowPremiumChanged", true);
    if (setting.escrowSettlement === false) {
      setValue("titleSettlementMeta.escrowSettlement", false);
      setValue("titleSettlementMeta.premiumText", premiumText);
    }

    if (setting.ownersPolicy === false) {
      setValue("titleSettlementMeta.ownersPolicy", false);
      setValue("titleSettlementMeta.premiumText", premiumText);
    }

    if (setting.lendersPolicy === false) {
      setValue("titleSettlementMeta.lendersPolicy", false);
      setValue("titleSettlementMeta.premiumText", premiumText);
    }
    closeModal();
  };

  // keep original UI structure and classes exactly; replace inputs with Controller wrappers
  return (
    <>
      <div className="model-body-calc-pg">
        <div
          className="calculator-page application-fe"
          onFocusCapture={handleFocusCapture}
        >
          <CommonHeader title={`Seller2Net Sheet`}>
            <div className="ch-btnsave">
              <button
                type="button"
                value="New"
                className="ch-btnsave-new"
                onClick={() => props.onClose()}
              >
                New
              </button>
              {!isGuestUser(user) && (
                <button
                  type="button"
                  value="Save"
                  className="ch-btnsave-save"
                  onClick={() => props.handleSaveCalc()}
                >
                  Save
                </button>
              )}
            </div>
          </CommonHeader>
          <div className="row-three-wrap">
            <div className="calc-column-a">
              <GeneralInformationSection
                // FloatingInput={FloatingInput}
                control={control}
                getValues={getValues}
                setValue={setValue}
                user={user}
                openModal={openModal}
                closeModal={closeModal}
                showToaster={showToaster}
              />

              <h3 className="m-top-24 m-btm-16">
                Seller Must Net and Loan Info
              </h3>

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group">
                  <span className="heading-c">Loan to be Paid or Assumed</span>
                  <div className="switch-wrap">
                    <div className="switch-wrap-a">
                      <Controller
                        name="loanInfoMeta.autoEstimateLoan"
                        control={control}
                        defaultValue={
                          !!getVal("loanInfoMeta.autoEstimateLoan", false)
                        }
                        render={({ field }) => (
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="toggle"
                              checked={!!field.value}
                              onChange={(e) => {
                                try {
                                  const checked = !!e.target.checked;
                                  // update RHF value
                                  field.onChange && field.onChange(checked);
                                  // keep parent state in sync so PropertyDetailsSection reflects the same choice
                                  setUseMortgageBalance &&
                                    setUseMortgageBalance(checked);

                                  if (checked) {
                                    // auto estimate enabled -> copy ttbData loanBalance into loansToBePaid first row
                                    const bal =
                                      ttbData?.loanBalance?.balance ?? "";
                                    const rate =
                                      ttbData?.loanBalance?.interestRate ?? "";
                                    setValue &&
                                      setValue(
                                        "loanInfoMeta.loansToBePaidBalance1",
                                        bal
                                      );
                                    setValue &&
                                      setValue(
                                        "loanInfoMeta.loansToBePaidRate1",
                                        rate
                                      );
                                  } else {
                                    // auto estimate disabled -> copy mortgageAmount into loansToBePaidBalance1
                                    const mort = getValues
                                      ? getValues("loanInfoMeta.mortgageAmount")
                                      : "";
                                    setValue &&
                                      setValue(
                                        "loanInfoMeta.loansToBePaidBalance1",
                                        mort || "0.00"
                                      );
                                  }
                                } catch (err) {
                                  console.warn(
                                    "Failed toggling autoEstimateLoan sync",
                                    err
                                  );
                                }
                              }}
                            />
                            <span class="slider"></span>
                          </label>
                        )}
                      />
                    </div>
                    <div className="switch-wrap-b">
                      <p className="tooltip">
                        Auto Estimate Loan
                        <span class="tooltip-text">
                          <ul>
                            <li>
                              <b>Balance</b> is derived from transaction
                              history.
                            </li>
                            <li>
                              <b>Rate</b> is based on loan rates at the time of
                              origination.
                            </li>
                            <li>
                              This is only an estimate and may be different
                              based on the borrower's repayment history.
                            </li>
                          </ul>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <LoansToBePaid
                control={control}
                FloatingInput={FloatingNumber}
                getValues={getValues}
                cleanNumber={cleanNumber}
              />

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group sign-of-amount">
                  <ControlledField
                    name="loanInfoMeta.annualPropertyTaxAmount"
                    control={control}
                    InputComponent={FloatingNumber}
                    label="Annual Property Tax $"
                    placeholder=""
                    type="text"
                    defaultValue={getVal(
                      "loanInfoMeta.annualPropertyTaxAmount",
                      "0.00"
                    )}
                    cleanNumber={cleanNumber}
                  />
                </div>{" "}
                {/*}
                <div className="calc-frm-fld form-group">
                  (Used for Prorations)
                </div>{*/}
              </div>

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group">
                  <span className="heading-c">Loan Information</span>
                </div>
              </div>

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group ">
                  <label className="lbl-section">Loan Type </label>
                  <Controller
                    name="loanInfoMeta.buyersLoanType"
                    control={control}
                    defaultValue={getVal(
                      "loanInfoMeta.buyersLoanType",
                      "Conventional"
                    )}
                    render={({ field }) => (
                      <CustomSelect
                        {...field}
                        placeholder={getVal("loanInfoMeta.buyersLoanType", "")}
                        options={[
                          "FHA 203b",
                          "VA",
                          "USDA",
                          "Conventional",
                          "Cash",
                          "Owner Carry",
                        ]}
                        onChange={(val) => {
                          // only forward the change to RHF here; the parent will react via watch
                          try {
                            field.onChange && field.onChange(val);
                          } catch (err) {
                            // ignore
                          }
                        }}
                      />
                    )}
                  />
                </div>
                {/* Show Conventional % only when buyersLoanType is Conventional */}
                {((typeof watch === "function"
                  ? watch("loanInfoMeta.buyersLoanType")
                  : getVal("loanInfoMeta.buyersLoanType")) ||
                  getVal("loanInfoMeta.buyersLoanType", "Conventional")) ===
                  "Conventional" && (
                    <div className="calc-frm-fld form-group sign-of-percentage">
                      <ControlledField
                        name="loanInfoMeta.conventionalPercent"
                        control={control}
                        defaultValue={getVal(
                          "loanInfoMeta.conventionalPercent",
                          "0.00"
                        )}
                        InputComponent={FloatingNumber}
                        placeholder=""
                        label="Conventional %"
                        type="text"
                        cleanNumber={cleanNumber}
                        handleCurrencyBlur={handleCurrencyBlur}
                      />
                    </div>
                  )}
              </div>

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group sign-of-amount">
                  <ControlledField
                    name="loanInfoMeta.buyerDownPayment"
                    control={control}
                    InputComponent={FloatingNumber}
                    className="input-filled"
                    label="Buyer Down Payment $ / %"
                    placeholder=""
                    type="text"
                    defaultValue={getVal("loanInfoMeta.buyerDownPayment", "")}
                    cleanNumber={cleanNumber}
                    handleCurrencyBlur={handleCurrencyBlur}
                  />
                </div>
              </div>

              {loanType === "Owner Carry" && (
                <OwnerCarrySection
                  control={control}
                  FloatingNumber={FloatingNumber}
                  getVal={getVal}
                  setValue={setValue}
                  handleCurrencyBlur={handleCurrencyBlur}
                  salesPriceFormattedTick={salesPriceFormattedTick}
                  onSalesPriceBlur={onSalesPriceBlur}
                />
              )}

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group">
                  <Controller
                    name="loanInfoMeta.estimatedClosingDate"
                    control={control}
                    defaultValue={getVal(
                      "loanInfoMeta.estimatedClosingDate",
                      ""
                    )}
                    render={({ field }) => (
                      <FloatingInput
                        {...field}
                        type="date"
                        label=""
                        placeholder="MM/DD/YYYY"
                        className="inpt-pla"
                      />
                    )}
                  />
                  <label htmlFor="input-amount1">Estimated Closing Date</label>
                </div>
              </div>

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group sign-of-amount">
                  <ControlledField
                    name="sellerMustNet"
                    control={control}
                    InputComponent={FloatingNumber}
                    label="Seller Must Net"
                    placeholder=""
                    className="input-filled"
                    type="text"
                    defaultValue={getVal("sellerMustNet", "")}
                    cleanNumber={cleanNumber}
                    onFormatted={(name, formatted) => {
                      // notify dependents that salesPrice was formatted (blur)
                      // Do NOT trigger the heavy onSalesPriceBlur here — use the Calculate button instead
                      setSalesPriceFormattedTick((t) => t + 1);
                      //handleCalAmount && handleCalAmount(formatted);
                    }}
                  />
                </div>
              </div>

              <div className="calculate-btn">
                <button
                  type="button"
                  value="Calculate"
                  className="submit-btn btn-bg inpt-btn"
                  disabled={!!calcCompleted || isCalculating}
                  onClick={async () => {
                    try {
                      if (isCalculating || calcCompleted) return;
                      setIsCalculating(true);

                      const val = getVal("sellerMustNet", "") || "";
                      const sellerMustNetNum = cleanNumber(val);
                      if (!(sellerMustNetNum > 0)) {
                        if (typeof showToaster === "function") {
                          showToaster({
                            message: "Please enter the Seller Must Net.",
                            visible: true,
                            type: "error",
                          });
                        }
                        return;
                      }
                      // pass the formatted/current sellerMustNet to the parent onSalesPriceBlur handler
                      if (onSalesPriceBlur) {
                        await onSalesPriceBlur(val);
                      }
                      // Notify parent that calculation has completed (locks editing)
                      if (typeof props.onCalculationComplete === "function") {
                        props.onCalculationComplete();
                      }
                    } catch (err) {
                      console.warn("Calculate button onClick failed", err);
                    } finally {
                      setIsCalculating(false);
                    }
                  }}
                >
                  Calculate
                </button>
              </div>
            </div>

            <div className="calc-column-b">
              <h3 className="m-btm-16">Closing Costs</h3>

              <EscrowTitleFields
                control={control}
                FloatingInput={FloatingInput}
                FloatingNumber={FloatingNumber}
                CustomSelect={CustomSelect}
                cleanNumber={cleanNumber}
                getValues={getValues}
                setValue={setValue}
                EscrowDisabled={EscrowDisabled}
                onContinue={handleContinue}
                openModal={openModal}
                closeModal={closeModal}
              />

              {/* Dynamic Seller Other Costs — render only when parent field-array exists. */}
              {sellerClosingCostArray &&
                Array.isArray(sellerClosingCostArray.fields) &&
                sellerClosingCostArray.fields.length > 0 && (
                  <SellerClosingCosts
                    fields={sellerClosingCostArray.fields}
                    control={control}
                    FloatingInput={FloatingInput}
                    cleanNumber={cleanNumber}
                    parentName="sellerClosingCostMeta"
                    salesPrice={getVal("salesPrice", "")}
                    getValues={getValues}
                    setValue={setValue}
                  />
                )}

              {getValues && getValues("escrowPremiumChanged") && (
                <p className="premium-txt">{EscrowDisabled.premiumText}</p>
              )}

              <h3 className="m-btm-16 m-top-24">Compensation</h3>
              {compensationArray &&
                Array.isArray(compensationArray.fields) &&
                compensationArray.fields.length > 0 && (
                  <CompensationFields
                    control={control}
                    FloatingInput={FloatingInput}
                    fields={compensationArray.fields}
                    cleanNumber={cleanNumber}
                    parentName="compensationMeta"
                    getValues={getValues}
                    setValue={setValue}
                    salesPriceFormattedTick={salesPriceFormattedTick}
                    handleSellerCalculation={handleSellerCalculation}
                  />
                )}
              <div className="table-calc-frm">
                <div className="table-calc-frm-inner">
                  <div className="calc-frm-field m-top-24">
                    <div className="calc-frm-fld form-group clmn-a-width">
                      <span className="heading-c">Cost</span>
                    </div>
                    <div className="calc-frm-fld form-group clmn-b-width">
                      <span className="heading-c">Type</span>
                    </div>
                    <div className="calc-frm-fld form-group clmn-c-width">
                      <span className="heading-c">Rate</span>
                    </div>
                    <div className="calc-frm-fld form-group fld-txt-right clmn-d-width">
                      <span className="heading-c">Total</span>
                    </div>
                  </div>

                  {/* Prefer rendering the RHF field-array when available so each
                      ManualField binds directly to its array item. This ensures
                      edits update the corresponding closingCostMeta element. */}
                  {closingCostsSection2Array &&
                    Array.isArray(closingCostsSection2Array.fields) &&
                    closingCostsSection2Array.fields.length
                    ? closingCostsSection2Array.fields.map((item, idx) => (
                      <ManualField
                        key={item.id || `${item.camelKey}-${idx}`}
                        row={costRows[idx]}
                        index={idx}
                        fieldItem={item}
                        control={control}
                        FloatingInput={FloatingInput}
                        FloatingNumber={FloatingNumber}
                        CustomSelect={CustomSelect}
                        cleanNumber={cleanNumber}
                        getValues={getValues}
                        setValue={setValue}
                        salesPriceFormattedTick={salesPriceFormattedTick}
                      />
                    ))
                    : costRows.map((r) => (
                      <ManualField
                        key={r.left.name}
                        row={r}
                        control={control}
                        FloatingInput={FloatingInput}
                        FloatingNumber={FloatingNumber}
                        CustomSelect={CustomSelect}
                        /* ManualField writes into RHF via setValue/getValues */
                        cleanNumber={cleanNumber}
                        getValues={getValues}
                        setValue={setValue}
                        salesPriceFormattedTick={salesPriceFormattedTick}
                      />
                    ))}
                </div>
              </div>
              <div className="calc-frm-field">
                <div className="total-amunt-fld">
                  <div className="amount-txt heading-c">
                    Total Closing Costs
                  </div>
                  <div className="amount-number heading-c">
                    ${" "}
                    {formatCurrency(
                      (watch
                        ? watch("totalClosingMeta")
                        : getVal("totalClosingMeta", {})
                      )?.sellerCostsTotal
                    ) || "0.00"}
                  </div>
                </div>
              </div>
            </div>

            <div className="calc-column-c">
              <h3 className="m-btm-16">Other Costs</h3>

              <div className="calc-frm-field">
                <DiscountFields
                  fields={
                    otherCostArray && Array.isArray(otherCostArray.fields)
                      ? otherCostArray.fields
                      : getVal("otherCostMeta", [])
                  }
                  control={control}
                  FloatingNumber={FloatingNumber}
                  cleanNumber={cleanNumber}
                  parentName="otherCostMeta"
                  getValues={getValues}
                  setValue={setValue}
                  salesPriceFormattedTick={salesPriceFormattedTick}
                />
              </div>

              {sellerOtherCostArray &&
                Array.isArray(sellerOtherCostArray.fields) &&
                sellerOtherCostArray.fields.length > 0 && (
                  <OtherCostsFields
                    control={control}
                    FloatingInput={FloatingInput}
                    // pass the field-array object so OtherCostsFields can react to replace/push/remove
                    sellerOtherCostArray={sellerOtherCostArray}
                    // keep fields prop for backward compatibility
                    fields={sellerOtherCostArray.fields}
                    cleanNumber={cleanNumber}
                    parentName="sellerOtherCostMeta"
                    getValues={getValues}
                    setValue={setValue}
                  />
                )}

              <div className="calc-frm-field">
                <div className="calc-frm-fld form-group full-gp">
                  <span className="heading-c full-gp-txt">
                    Total Other Costs to Buyer
                  </span>
                  <span className="heading-c txt-right-align full-gp-amount">
                    ${" "}
                    {formatCurrency(
                      (watch
                        ? watch("totalClosingMeta")
                        : getVal("totalClosingMeta", {})
                      )?.otherCostsTotal
                    ) || "0.00"}
                  </span>
                </div>
              </div>

              <div className="box-wrap">
                <div className="box-layout-head">
                  <h3>Sales Price</h3>
                </div>
                <div className="wrap-middle-container">
                  <div className="totl-estimate box-ly">
                    <div className="totl-estimate-txt heading-c">
                      Total All Costs and
                      Credits&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$
                    </div>
                    <div className="totl-estimate-amnt heading-c">
                      {formatCurrency(
                        (watch
                          ? watch("totalClosingMeta")
                          : getVal("totalClosingMeta", {})
                        )?.allCostsTotal
                      ) ?? "0.00"}
                    </div>
                  </div>
                  <div className="calc-frm-field b-top mg-top-16 pd-top-16">
                    <div className="calc-frm-fld form-group">
                      <ControlledField
                        name="loanInfoMeta.estimatedTaxProrations"
                        control={control}
                        defaultValue={getVal(
                          "loanInfoMeta.estimatedTaxProrations",
                          ""
                        )}
                        InputComponent={FloatingNumber}
                        placeholder=""
                        label="Estimated Tax Prorations $"
                        type="text"
                        cleanNumber={cleanNumber}
                      />
                    </div>
                  </div>
                  <div className="totl-estimate box-ly">
                    <div className="totl-estimate-txt heading-c">
                      Sales Price&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;$
                    </div>
                    {/* show updated salesPrice here */}
                    <div className="totl-estimate-amnt heading-c">
                      {formatCurrency(watchedSalesPrice) || "0.00"}
                    </div>
                  </div>
                </div>
                <div className="box-action">
                  <ul>
                    <li>
                      <button
                        className="icon-pdf"
                        onClick={(e) => {
                          const isValid = checkValidSalesPrice();
                          if (!isValid) return;
                          if (templateMissing) {
                            try {
                              try {
                                showInvalidAddressToast(showToaster);
                              } catch (e) {
                                /* ignore */
                              }
                            } catch (err) {
                              /* ignore */
                            }
                            return;
                          }
                          handleDownloadPrintPDF("download");
                        }}
                      >
                        Save PDF
                      </button>
                    </li>
                    <li>
                      <button
                        className="icon-print"
                        onClick={(e) => {
                          const isValid = checkValidSalesPrice();
                          if (!isValid) return;
                          if (templateMissing) {
                            try {
                              try {
                                showInvalidAddressToast(showToaster);
                              } catch (e) {
                                /* ignore */
                              }
                            } catch (err) {
                              /* ignore */
                            }
                            return;
                          }
                          handleDownloadPrintPDF("print");
                        }}
                      >
                        Print
                      </button>
                    </li>
                    <li>
                      <button
                        className="icon-email"
                        onClick={(e) => {
                          const isValid = checkValidSalesPrice();
                          if (!isValid) return;

                          if (templateMissing) {
                            try {
                              try {
                                showInvalidAddressToast(showToaster);
                              } catch (e) {
                                /* ignore */
                              }
                            } catch (err) {
                              /* ignore */
                            }
                            return;
                          }
                          const updated = buildSellerNetPayload({
                            getVal,
                            user,
                            calculatorname: "Seller2Net Sheet",
                          });
                          openModal({
                            title: "Email a Closing Cost Estimate",
                            size: "mediumsizewidth",
                            content: (
                              <EmailModal
                                onClose={closeModal}
                                type="seller2Net"
                                showToaster={showToaster}
                                sellerFormData={updated}
                              />
                            ),
                          });
                        }}
                      >
                        Email
                      </button>
                    </li>
                    <li>
                      <button
                        className="icon-text"
                        onClick={(e) => {
                          const isValid = checkValidSalesPrice();
                          if (!isValid) return;
                          if (templateMissing) {
                            try {
                              try {
                                showInvalidAddressToast(showToaster);
                              } catch (e) {
                                /* ignore */
                              }
                            } catch (err) {
                              /* ignore */
                            }
                            return;
                          }
                          const updated = buildSellerNetPayload({
                            getVal,
                            user,
                            calculatorname: "Seller2Net Sheet",
                          });
                          openModal({
                            title: "Text Message to Customer",
                            size: "mediumsizewidth",
                            content: (
                              <TextMessageModal
                                onClose={closeModal}
                                type="seller2Net"
                                showToaster={showToaster}
                                sellerFormData={updated}
                              />
                            ),
                          });
                        }}
                      >
                        Text
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="calc-frm-field">
                <a
                  href="javascript:void(0);"
                  className="icon-info"
                  onClick={(e) => {
                    e.preventDefault();
                    openModal({
                      title: "Disclaimer",
                      size: "mediumsizewidth",
                      content: (
                        <DisclaimerModal calc="seller" onClose={closeModal} />
                      ),
                    });
                  }}
                >
                  Disclaimer
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
